import { redirect } from '@tanstack/react-router';

// Signup waits for account readiness on `/signup` and never routes to `/post_registration`, so the
// only visits left are bookmarks. The index route lands them on their workspace. Replace, so Back
// doesn't return here only to be sent forward again.
export function redirectPostRegistrationToRoot(): never {
  throw redirect({ to: '/', replace: true });
}
